import { UI_STATES } from '../constants/commonConstants';
import {
	GET_SWITCH_ALARM_COUNT_FAIL,
	GET_SWITCH_ALARM_COUNT_SUCCESS,
	GLOBAL_VLAN_CREATE_FAIL,
	GLOBAL_VLAN_CREATE_SUCCESS,
	GLOBAL_VLAN_DELETE_FAIL,
	GLOBAL_VLAN_DELETE_SUCCESS,
	GLOBAL_VLAN_LIST_GET_FAIL,
	GLOBAL_VLAN_LIST_GET_SUCCESS,
	GLOBAL_VLAN_LIST_REQUEST_GET,
	GLOBAL_VLAN_REQUEST_CREATE,
	GLOBAL_VLAN_REQUEST_DELETE,
	GLOBAL_VLAN_REQUEST_UPDATE,
	GLOBAL_VLAN_UPDATE_FAIL,
	GLOBAL_VLAN_UPDATE_SUCCESS,
	RESET_ADD_SWITCH,
	RESET_DELETE_SWITCH,
	RESET_UPDATE_PORT_CONFIGURATION,
	SWITCH_ADD_FAIL,
	SWITCH_ADD_SUCCESS,
	SWITCH_ADD_TRIGGER,
	SWITCH_DELETE_FAIL,
	SWITCH_DELETE_SUCCESS,
	SWITCH_DETAILS_GET,
	SWITCH_DETAILS_GET_FAIL,
	SWITCH_DETAILS_GET_SUCCESS,
	SWITCH_LIST_GET_FAIL,
	SWITCH_LIST_GET_SUCCESS,
	SWITCH_LIST_REQUEST_GET,
	SWITCH_PORT_REQUEST_UPDATE,
	SWITCH_PORT_UPDATE_FAIL,
	SWITCH_PORT_UPDATE_SUCCESS,
	SWITCH_PORTS_GET,
	SWITCH_PORTS_GET_FAIL,
	SWITCH_PORTS_GET_SUCCESS,
	SWITCH_REQUEST_ADD,
	SWITCH_REQUEST_DELETE,
	SWITCH_VLANS_GET,
	SWITCH_VLANS_GET_FAIL,
	SWITCH_VLANS_GET_SUCCESS,
	GET_STATIC_MAC_LIST,
	GET_STATIC_MAC_LIST_SUCCESS,
	GET_STATIC_MAC_LIST_FAILURE,
	GET_PORT_STATICS_LIST,
	GET_PORT_STATICS_LIST_SUCCESS,
	GET_PORT_STATICS_LIST_FAILURE,
	GET_POE_UTILISATION_LIST,
	GET_POE_UTILISATION_LIST_SUCCESS,
	GET_POE_UTILISATION_LIST_FAILURE,
	GET_CPU_UTILISATION_LIST,
	GET_CPU_UTILISATION_LIST_SUCCESS,
	GET_CPU_UTILISATION_LIST_FAILURE,
	GET_SWITCH_TRAFFIC_LIST,
	GET_SWITCH_TRAFFIC_LIST_SUCCESS,
	GET_SWITCH_TRAFFIC_LIST_FAILURE,
	POST_MOVE_SWITCH,
	RESET_MOVE_SWITCH,
	POST_MOVE_SWITCH_SUCCESS,
	POST_MOVE_SWITCH_FAIL,
	GET_NETWORK_INTERFACES_LIST,
	GET_NETWORK_INTERFACES_LIST_SUCCESS,
	GET_NETWORK_INTERFACES_LIST_FAILURE,
	GET_NETWORK_ROUTES_LIST,
	GET_NETWORK_ROUTES_LIST_SUCCESS,
	GET_NETWORK_ROUTES_LIST_FAILURE,
	GET_NETWORK_NEIGHBOUR_CACHE_LIST,
	GET_NETWORK_NEIGHBOUR_CACHE_LIST_SUCCESS,
	GET_NETWORK_NEIGHBOUR_CACHE_LIST_FAILURE,
	GET_SWITCH_ALARMS_LIST,
	GET_SWITCH_ALARMS_LIST_SUCCESS,
	GET_SWITCH_ALARMS_LIST_FAILURE,
	CLEAR_PORT_STATICS_LIST,
	CLEAR_PORT_STATICS_LIST_SUCCESS,
	CLEAR_PORT_STATICS_LIST_FAILURE,
	RESET_PORT_STATICS_CLEAR_STATE,
	GET_PORT_CONFS_LIST,
	GET_PORT_CONFS_LIST_SUCCESS,
	GET_PORT_CONFS_LIST_FAILURE,
	SWITCH_DASH_DOWNLOAD,
	SWITCH_DASH_DOWNLOAD_SUCCESS,
	SWITCH_PORTS_ACL_GET,
	SWITCH_PORTS_ACL_GET_SUCCESS,
	SWITCH_PORTS_ACL_GET_FAIL,
	GET_LLDP_REMOTE_DEVICES_LIST,
	GET_LLDP_REMOTE_DEVICES_LIST_SUCCESS,
	GET_LLDP_REMOTE_DEVICES_LIST_FAILURE,
	SWITCH_ACL_MAC_GET,
	SWITCH_ACL_MAC_GET_SUCCESS,
	SWITCH_ACL_MAC_GET_FAIL,
	SWITCH_ACL_IPV4_GET,
	SWITCH_ACL_IPV4_GET_SUCCESS,
	SWITCH_ACL_IPV4_GET_FAIL,
	SWITCH_ACL_IPV6_GET,
	SWITCH_ACL_IPV6_GET_SUCCESS,
	SWITCH_ACL_IPV6_GET_FAIL,
	SWITCH_TEMPRATURE_GRAPH_API_REQUEST,
	SWITCH_TEMPRATURE_GRAPH_API_SUCCESS,
	SWITCH_TEMPRATURE_GRAPH_API_FAIL,
	RESET_GLOBAL_VLAN_DELETE,
	SHOW_SWITCH_MODAL,
	RESET_GLOBAL_VLAN_ADD,
	RESET_GLOBAL_VLAN_UPDATE,
	SWITCH_PORTS_FOR_POE_GET,
	SWITCH_PORTS_FOR_POE_GET_SUCCESS,
	SWITCH_PORTS_FOR_POE_GET_FAIL
} from '../constants/switchConstants';

export const switchApiReducer = (
	state = { 
		apList: {}, 
		addApResp: {}, 
		macList : {},
		cpuData : {
			status: null,
			data : []
		}, 
		trafficData : {
			status : null,
			data : []
		},
		portsAclData: {
			status: null,
			data: [],
		  },
		macAclData: {
			status: null,
			data: [],
		},
		ipv4AclData: {
			status: null,
			data: [],
		},
		ipv6AclData: {
			status: null,
			data: [],
		},
		switchTemprature : {
			swtichTemApiLoading: true,
			data: [],
			error: null
		}
	},
	action
) => {
	switch (action.type) {
		case SWITCH_LIST_REQUEST_GET:
			return {
				...state,
				switchListState: {
					...(state.switchListState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_LIST_GET_SUCCESS:
			return {
				...state,
				switchListState: {
					...(state.switchListState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case SWITCH_LIST_GET_FAIL:
			return {
				...state,
				switchListState: {
					...(state.switchListState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GLOBAL_VLAN_LIST_REQUEST_GET:
			return {
				...state,
				globalVlanListState: {
					...(state.globalVlanListState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case GLOBAL_VLAN_LIST_GET_SUCCESS:
			return {
				...state,
				globalVlanListState: {
					...(state.globalVlanListState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GLOBAL_VLAN_LIST_GET_FAIL:
			return {
				...state,
				globalVlanListState: {
					...(state.globalVlanListState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GLOBAL_VLAN_REQUEST_CREATE:
			return {
				...state,
				globalVlanCreateState: {
					status: UI_STATES.LOADING,
				},
			};
		case GLOBAL_VLAN_CREATE_SUCCESS:
			return {
				...state,
				globalVlanCreateState: {
					status: UI_STATES.SUCCESS,
				},
			};
		case GLOBAL_VLAN_CREATE_FAIL:
			return {
				...state,
				globalVlanCreateState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
			case RESET_GLOBAL_VLAN_ADD:
			return {
				...state,
				globalVlanCreateState: {
					status: null,
					message: null,
				},
			};
		case GLOBAL_VLAN_REQUEST_UPDATE:
			return {
				...state,
				globalVlanUpdateState: {
					status: UI_STATES.LOADING,
				},
			};
		case GLOBAL_VLAN_UPDATE_SUCCESS:
			return {
				...state,
				globalVlanUpdateState: {
					status: UI_STATES.SUCCESS,
				},
			};
		case GLOBAL_VLAN_UPDATE_FAIL:
			return {
				...state,
				globalVlanUpdateState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
			case RESET_GLOBAL_VLAN_UPDATE:
			return {
				...state,
				globalVlanUpdateState: {
					status: null,
					message: null,
				},
			};
		case GLOBAL_VLAN_REQUEST_DELETE:
			return {
				...state,
				globalVlanDeleteState: {
					status: UI_STATES.LOADING,
				},
			};
		case GLOBAL_VLAN_DELETE_SUCCESS:
			return {
				...state,
				globalVlanDeleteState: {
					status: UI_STATES.SUCCESS,
				},
			};
		case GLOBAL_VLAN_DELETE_FAIL:
			return {
				...state,
				globalVlanDeleteState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
		case RESET_GLOBAL_VLAN_DELETE:
			return {
				...state,
				globalVlanDeleteState: {
					status: null,
					message: null,
				},
			};
		case SWITCH_PORTS_GET:
			return {
				...state,
				switchPortsGetState: {
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_PORTS_GET_SUCCESS:
			return {
				...state,
				switchPortsGetState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case SWITCH_PORTS_GET_FAIL:
			return {
				...state,
				switchPortsGetState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
		case SWITCH_PORTS_FOR_POE_GET:
			return {
				...state,
				switchPortsPoeGetState: {
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_PORTS_FOR_POE_GET_SUCCESS:
			return {
				...state,
				switchPortsPoeGetState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case SWITCH_PORTS_FOR_POE_GET_FAIL:
			return {
				...state,
				switchPortsPoeGetState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
		case SWITCH_PORT_REQUEST_UPDATE:
			return {
				...state,
				portsUpdateState: {
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_PORT_UPDATE_SUCCESS:
			return {
				...state,
				portsUpdateState: {
					status: UI_STATES.SUCCESS,
				},
			};
		case SWITCH_PORT_UPDATE_FAIL:
			return {
				...state,
				portsUpdateState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_UPDATE_PORT_CONFIGURATION:
			return {
				...state,
				portsUpdateState: {
					status: null,
					error: null,
				},
			};
		case SWITCH_VLANS_GET:
			return {
				...state,
				switchVlansGetState: {
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_VLANS_GET_SUCCESS:
			return {
				...state,
				switchVlansGetState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case SWITCH_VLANS_GET_FAIL:
			return {
				...state,
				switchVlansGetState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
		case SWITCH_DETAILS_GET:
			return {
				...state,
				switchDetailsGetState: {
					status: UI_STATES.LOADING,
					apiStatus : true
				},
			};
		case SWITCH_DETAILS_GET_SUCCESS:
			return {
				...state,
				switchDetailsGetState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
					apiStatus : false
				},
			};
		case SWITCH_DETAILS_GET_FAIL:
			return {
				...state,
				switchDetailsGetState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
					apiStatus : false
				},
			};
		case GET_SWITCH_ALARM_COUNT_SUCCESS:
			return {
				...state,
				switchAlarmCountState: {
					data: action.payload,
				},
			};
		case GET_SWITCH_ALARM_COUNT_FAIL:
			return {
				...state,
				switchAlarmCountState: {
					status: UI_STATES.FAILURE,
					message: action.payload,
				},
			};
		case GET_STATIC_MAC_LIST:
			return {
				...state,
				macListState: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_STATIC_MAC_LIST_SUCCESS:
			return {
				...state,
				macListState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_STATIC_MAC_LIST_FAILURE:
			return {
				...state,
				macListState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GET_SWITCH_ALARMS_LIST:
			return {
				...state,
				alarmsListState: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_SWITCH_ALARMS_LIST_SUCCESS:
			return {
				...state,
				alarmsListState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_SWITCH_ALARMS_LIST_FAILURE:
			return {
				...state,
				alarmsListState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GET_POE_UTILISATION_LIST:
			return {
				...state,
				poeData: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_POE_UTILISATION_LIST_SUCCESS:
			return {
				...state,
				poeData: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_POE_UTILISATION_LIST_FAILURE:
			return {
				...state,
				poeData: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GET_PORT_CONFS_LIST:
			return {
				...state,
				portConfsData: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_PORT_CONFS_LIST_SUCCESS:
			return {
				...state,
				portConfsData: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_PORT_CONFS_LIST_FAILURE:
			return {
				...state,
				portConfsData: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
			case GET_CPU_UTILISATION_LIST:
			return {
				...state,
				cpuData: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_CPU_UTILISATION_LIST_SUCCESS:
			return {
				...state,
				cpuData: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_CPU_UTILISATION_LIST_FAILURE:
			return {
				...state,
				cpuData: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		
			case GET_SWITCH_TRAFFIC_LIST:
				return {
					...state,
					trafficData: {
						data:[],
						status: UI_STATES.LOADING,
					},
				};
			case GET_SWITCH_TRAFFIC_LIST_SUCCESS:
				return {
					...state,
					trafficData: {
						status: UI_STATES.SUCCESS,
						data: action.payload,
					},
				};
			case GET_SWITCH_TRAFFIC_LIST_FAILURE:
				return {
					...state,
					trafficData: {
						status: UI_STATES.FAILURE,
						data : [],
						error: action.payload,
					},
				};
		case SWITCH_TEMPRATURE_GRAPH_API_REQUEST:
			return {
				...state,
					switchTemprature: {
					loading: true,
					data: [],
					error: null
				}
			};
		case SWITCH_TEMPRATURE_GRAPH_API_SUCCESS:
			return {
				...state,
					switchTemprature: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case SWITCH_TEMPRATURE_GRAPH_API_FAIL:
			return {
				...state,
					switchTemprature: {
					loading: false,
					data: [],
					error: action.payload
				}
			};
		case GET_PORT_STATICS_LIST:
			return {
				...state,
				portStatisticsState: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_PORT_STATICS_LIST_SUCCESS:
			return {
				...state,
				portStatisticsState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_PORT_STATICS_LIST_FAILURE:
			return {
				...state,
				portStatisticsState: {
					status: UI_STATES.FAILURE,
				},
			};
		case GET_LLDP_REMOTE_DEVICES_LIST:
			return {
				...state,
				portLldpRemoteDevicesState: {
					status: UI_STATES.LOADING,
				},
			};
		case GET_LLDP_REMOTE_DEVICES_LIST_SUCCESS:
			return {
				...state,
				portLldpRemoteDevicesState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_LLDP_REMOTE_DEVICES_LIST_FAILURE:
			return {
				...state,
				portLldpRemoteDevicesState: {
					status: UI_STATES.FAILURE,
				},
			};
		case CLEAR_PORT_STATICS_LIST:
			return {
				...state,
				portStatisticsClearState: {
					status: UI_STATES.LOADING,
				},
			};
		case CLEAR_PORT_STATICS_LIST_SUCCESS:
			return {
				...state,
				portStatisticsClearState: {
					status: UI_STATES.SUCCESS,
				},
			};
		case CLEAR_PORT_STATICS_LIST_FAILURE:
			return {
				...state,
				portStatisticsClearState: {
					status: UI_STATES.FAILURE,
					error: action.payload
				},
			};
		case RESET_PORT_STATICS_CLEAR_STATE:
			return {
				...state,
				portStatisticsClearState: {
					status: null,
					error: null
				},
			}
		case SWITCH_PORTS_ACL_GET:
			return {
				...state,
				portsAclData: {
				status: UI_STATES.LOADING,
				},
			};
			case SWITCH_PORTS_ACL_GET_SUCCESS:
			return {
				...state,
				portsAclData: {
				status: UI_STATES.SUCCESS,
				data: action.payload
				},
			};
			case SWITCH_PORTS_ACL_GET_FAIL:
			return {
				...state,
				portsAclData: {
				status: UI_STATES.FAILURE,
				},
			};

			case SWITCH_ACL_MAC_GET:
			return {
				...state,
				macAclData: {
				status: UI_STATES.LOADING,
				},
			};
			case SWITCH_ACL_MAC_GET_SUCCESS:
			return {
				...state,
				macAclData: {
				status: UI_STATES.SUCCESS,
				data: action.payload
				},
			};
			case SWITCH_ACL_MAC_GET_FAIL:
			return {
				...state,
				macAclData: {
				status: UI_STATES.FAILURE,
				},
			};

			case SWITCH_ACL_IPV4_GET:
				return {
					...state,
					ipv4AclData: {
					status: UI_STATES.LOADING,
					},
				};
				case SWITCH_ACL_IPV4_GET_SUCCESS:
				return {
					...state,
					ipv4AclData: {
					status: UI_STATES.SUCCESS,
					data: action.payload
					},
				};
				case SWITCH_ACL_IPV4_GET_FAIL:
				return {
					...state,
					ipv4AclData: {
					status: UI_STATES.FAILURE,
					},
				};

				case SWITCH_ACL_IPV6_GET:
				return {
					...state,
					ipv6AclData: {
					status: UI_STATES.LOADING,
					},
				};
				case SWITCH_ACL_IPV6_GET_SUCCESS:
				return {
					...state,
					ipv6AclData: {
					status: UI_STATES.SUCCESS,
					data: action.payload
					},
				};
				case SWITCH_ACL_IPV6_GET_FAIL:
				return {
					...state,
					ipv6AclData: {
					status: UI_STATES.FAILURE,
					},
				};
		default:
			return state;
	}
};

export const switchNetworkApiReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case GET_NETWORK_INTERFACES_LIST:
			return {
				...state,
				switchNetworkInterfaceState: {
					...(state.switchNetworkInterfaceState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case GET_NETWORK_INTERFACES_LIST_SUCCESS:
			return {
				...state,
				switchNetworkInterfaceState: {
					...(state.switchNetworkInterfaceState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_NETWORK_INTERFACES_LIST_FAILURE:
			return {
				...state,
				switchNetworkInterfaceState: {
					...(state.switchNetworkInterfaceState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GET_NETWORK_ROUTES_LIST:
			return {
				...state,
				switchNetworkRoutesState: {
					...(state.switchNetworkRoutesState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case GET_NETWORK_ROUTES_LIST_SUCCESS:
			return {
				...state,
				switchNetworkRoutesState: {
					...(state.switchNetworkRoutesState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_NETWORK_ROUTES_LIST_FAILURE:
			return {
				...state,
				switchNetworkRoutesState: {
					...(state.switchNetworkRoutesState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case GET_NETWORK_NEIGHBOUR_CACHE_LIST:
			return {
				...state,
				switchNetworkNeighbourCacheState: {
					...(state.switchNetworkNeighbourCacheState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case GET_NETWORK_NEIGHBOUR_CACHE_LIST_SUCCESS:
			return {
				...state,
				switchNetworkNeighbourCacheState: {
					...(state.switchNetworkNeighbourCacheState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case GET_NETWORK_NEIGHBOUR_CACHE_LIST_FAILURE:
			return {
				...state,
				switchNetworkNeighbourCacheState: {
					...(state.switchNetworkNeighbourCacheState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		default:
			return state;
	}
};

export const switchAddReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case SWITCH_REQUEST_ADD:
			return {
				...state,
				switchAddState: {
					...(state.switchAddState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_ADD_SUCCESS:
			return {
				...state,
				switchAddState: {
					...(state.switchAddState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
					msg: action.msg,
				},
			};
		case SWITCH_ADD_FAIL:
			return {
				...state,
				switchAddState: {
					...(state.switchAddState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_ADD_SWITCH:
			return {
				...state,
				switchAddState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};

export const switchDeleteReducer = (state = { data: {} , switchLength: 0}, action) => {
	switch (action.type) {
		case SWITCH_REQUEST_DELETE:
			return {
				...state,
				switchDeleteState: {
					...(state.switchDeleteState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case SWITCH_DELETE_SUCCESS:
			return {
				...state,
				switchDeleteState: {
					...(state.switchDeleteState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
					msg: action.msg,
					switchLength: action.length
				},
			};
		case SWITCH_DELETE_FAIL:
			return {
				...state,
				switchDeleteState: {
					...(state.switchDeleteState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_DELETE_SWITCH:
			return {
				...state,
				switchDeleteState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
export const switchTriggerReducer = (
	state = { switchAddTrigger: false },
	action
) => {
	switch (action.type) {
		case SWITCH_ADD_TRIGGER:
			return {
				...state,
				switchAddTrigger: action.payload,
			};
		case SHOW_SWITCH_MODAL:
			return {
				...state,
				...action.payload,
			}
		default:
			return state;
	}
};

export const moveSwitchReducer = (
	state = { successMsg: '', errorMessage: '' },
	action
) => {
	switch (action.type) {
		case POST_MOVE_SWITCH:
			return {
				...state,
				loading: true,
			};
		case POST_MOVE_SWITCH_SUCCESS:
			return {
				...state,
				loading: false,
				successMsg: action.payload,
			};
		case POST_MOVE_SWITCH_FAIL:
			return {
				...state,
				loading: false,
				errorMessage: action.payload,
			};
		case RESET_MOVE_SWITCH:
			return {
				...state,
				loading: false,
				successMsg: '',
				errorMessage: '',
			};
		default:
			return state;
	}
};

export const switchDashDownloadReducer = (
	state = { switchDashDownload: false, showSwitchDownloadSuccessAlert:false },
	action
) => {
	switch (action.type) {
		case SWITCH_DASH_DOWNLOAD:
			return {
				...state,
				switchDashDownload: action.payload,
			};
		case SWITCH_DASH_DOWNLOAD_SUCCESS:
			return {
				...state,
				showSwitchDownloadSuccessAlert: action.payload,
			}
		default:
			return state;
	}
};